import { withAuth } from 'hocs/auth/with-auth';
import { AlbumInvite as AlbumInvitePage } from './album-invite';

// Signing in is optional; it decides where "Open album" goes.
const AlbumInvite = withAuth(AlbumInvitePage, true);

export { AlbumInvite };
